import { PURCHASE_ORDER_UPLOAD_FAIL, PURCHASE_ORDER_UPLOAD_SUCCESS } from './../../po-upload/store/actions/po-upload.action'
import { ActionToEventMapping, createFrom, EventService } from '@spartacus/core'
import { Injectable } from '@angular/core'
import { map } from 'rxjs/operators'
import { CheckoutConfig } from '../../checkout/config'
import { ActionsSubject } from '@ngrx/store'
import { ofType } from '@ngrx/effects'
import { EntityAction } from '@spartacus/core/src/state/utils/entity'
import { PoUploadFailed, PoUploadSuccess } from './po-upload.events'
import { ActiveCartService } from '@spartacus/cart/base/core'

@Injectable({
  providedIn: 'root'
})
export class MbPoUploadClickEventBuilder {

  constructor (protected eventService: EventService,
               protected activeCartService: ActiveCartService,
               protected checkoutConfig: CheckoutConfig,
               protected actionsSubject: ActionsSubject) {
    this.init()
  }

  protected init () {
    this.registerAddEntry()
  }

  protected registerAddEntry () {
    this.registerMapped({
      action: PURCHASE_ORDER_UPLOAD_SUCCESS,
      event: PoUploadSuccess,
    })
    this.registerMapped({
      action: PURCHASE_ORDER_UPLOAD_FAIL,
      event: PoUploadFailed,
    })
  }

  protected registerMapped<T> (mapping: ActionToEventMapping<T>) {
    const eventStream$ = this.getAction(mapping.action).pipe(
      map(action => createFrom(mapping.event as any, {
        ...action.payload
      }))
    )
    return this.eventService.register(mapping.event as any, eventStream$)
  }

  protected getAction (actionType: string | string[]) {
    return this.actionsSubject.pipe(
      ofType(...([] as string[]).concat(actionType)),
      map(v => v as EntityAction)
    )
  }
}
